import { render, staticRenderFns } from "./DoDelegateUploadPop.vue?vue&type=template&id=cb8c8e7c"
import script from "./DoDelegateUploadPop.vue?vue&type=script&lang=js"
export * from "./DoDelegateUploadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8c8e7c')) {
      api.createRecord('cb8c8e7c', component.options)
    } else {
      api.reload('cb8c8e7c', component.options)
    }
    module.hot.accept("./DoDelegateUploadPop.vue?vue&type=template&id=cb8c8e7c", function () {
      api.rerender('cb8c8e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DoDelegateUploadPop.vue"
export default component.exports